"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Highlight = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
/**
 * @related ['Highlighter']
 * @since 8.28.0
 */
var Highlight = /*#__PURE__*/_styledComponents.default.mark.withConfig({
  displayName: "Highlight",
  componentId: "c11n-8-107-0__sc-1dgp7ml-0"
})([""]);
exports.Highlight = Highlight;
Highlight.displayName = 'Highlight';

/** @component */